<template>
  <div v-if="isShow" class="dialog-radish">
    <span class="closedialog" @click="isShow = false">X</span>
    <div class="serch-company">
      <el-input
        v-model="searchKeyword"
        size="mini"
        style="width:70%"
        @keyup.enter.native="serchRadish(searchKeyword)"
      ></el-input>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="serchRadish(searchKeyword)">搜索</div>
    </div>
    <el-table ref="multipleTable" :data="table" size="mini" style="width: 100%" height="300px">
      <el-table-column type="index" width="60"></el-table-column>
      <el-table-column prop="姓名" label="姓名" width="100px">
        <template slot-scope="scope">
          <span class="simi-icon" size="mini" @click="getSimi(scope.row)"> <i :class="simiClass(scope.row)"></i> </span>
          <span :class="{ 'drawer-link': scope.row.rid }" @click="clickName(scope.row)">{{
            scope.row.姓名 || (radishMap[scope.row.rid] && radishMap[scope.row.rid].姓名)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="职能模块" label="职能" width="150px">
        <template slot-scope="scope">
          <template v-if="radishMap[scope.row.rid]">
            <span v-for="tag in radishMap[scope.row.rid].职能模块" :key="`${scope.row.rid}${tag}`" class="a-tag">{{
              tag
            }}</span>
          </template>
        </template>
      </el-table-column>
      <template v-if="status">
        <el-table-column :prop="status" :label="status"></el-table-column>
      </template>
      <el-table-column prop="职级" label="职级" width="50px"></el-table-column>
    </el-table>
    <!-- 绑定人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :style="`top:${searchTop};left:${searchLeft}`"
      :could-insert="true"
      choose-btn-text="绑定"
      @choose="bindRadish"
    >
    </serch-radish-dialog>
  </div>
</template>
<script>
import serchRadishDialog from '../component/serchRadishDialog.vue'

export default {
  components: { serchRadishDialog },
  props: {
    searchTop: { type: String, default: '150px' },
    searchLeft: { type: String, default: 'calc(50vw - 320px);' },
  },
  data() {
    return {
      isShow: false,
      table: [],
      searchKeyword: '',
      radishMap: {},
      status: '', // '来源公司'，'目标公司'
      selectThirdperson: null,
    }
  },
  methods: {
    open(table = [], isPevc = false, isStock = false, status = '') {
      this.isPevc = isPevc
      this.isStock = isStock
      this.isShow = true
      this.table = table
      this.status = status
      this.copyTable = JSON.parse(JSON.stringify(table))
      this.getRadishes()
    },
    simiClass(row) {
      if (row.status == 1) return 'el-icon-question icon-lightred'
      else if (row.status == 2) return 'el-icon-success icon-blue'
      else if (row.status == 3) return 'el-icon-warning icon-red'
      else if (row.status == 4) return 'el-icon-error icon-grey'
      else return ''
    },
    async getRadishes() {
      const rids = this.table.map(v => v.rid).filter(v => v)
      this.radishMap = {}
      if (rids.length > 0) {
        const res = await app.service('radish').simpleList({
          query: { _id: { $in: rids } },
          fields: { 职级: 1, 职能模块: 1, 姓名: 1 },
        })
        if (res.status === 'success') {
          const radishMap = {}
          res.data.forEach(v => {
            radishMap[v._id] = v
          })
          this.radishMap = radishMap
        }
      }
    },
    async getSimi(item) {
      if (!item.rid) return this.$message('该数据未与人选绑定')
      const copyObj = JSON.parse(JSON.stringify(item))
      copyObj._id = copyObj.rid
      copyObj.thirdId = copyObj.个人ID
      delete copyObj.rid
      delete copyObj.个人ID
      if (copyObj.status && copyObj.status > 0) {
        app.root.$refs.simiDialog.show(copyObj)
      }
    },
    serchRadish(str) {
      this.table = this.copyTable.filter(v => v.姓名.includes(str))
    },
    clickName(radish) {
      this.handleRadish = radish
      if (radish.rid) window.open(`${window.frontend}/#/radish-detail-blank/${radish.rid}`, '_blank')
      else this.openBindDialog(radish)
    },
    async openBindDialog(radish) {
      const defaultSerchRadishes = await this.getDefaultSerchData(radish)
      this.$refs.serchRadishDialog.open(radish, defaultSerchRadishes)
    },
    async getDefaultSerchData(radish) {
      const res = await app.service('company').defaultSerchRadishes(radish.姓名)
      if (res.status === 'success') return res.data
      else return []
    },
    async bindRadish(radish) {
      const copyRadish = JSON.parse(JSON.stringify(radish))
      const rid = copyRadish._id
      delete copyRadish._id
      for (const key in copyRadish) {
        this.handleRadish[key] = copyRadish[key]
      }
      if (this.isPevc) {
        const res = await app.service('statistics').bindPevcPerson({ _id: this.handleRadish._id, rid: rid })
        if (res.status === 'success') {
          this.$set(this.handleRadish, 'rid', rid)
          this.$message.success('绑定成功')
        } else this.$message.error(res.msg)
      } else if (this.isStock) {
        const res = await app.service('statistics').bindStockPerson({ _id: this.handleRadish._id, rid: rid })
        if (res.status === 'success') {
          this.$set(this.handleRadish, 'rid', rid)
          this.$message.success('绑定成功')
        } else this.$message.error(res.msg)
      } else {
        const res = await app.service('statistics').bindAmacPerson({ _id: this.handleRadish._id, rid: rid })
        if (res.status === 'success') {
          this.$set(this.handleRadish, 'rid', rid)
          this.$message.success('绑定成功')
        } else this.$message.error(res.msg)
      }
      // 该人选绑定协会数据
      // const res = await app
      //   .service('radish')
      //   .bindThird({ rid: rid, third: { person: { 个人ID: this.handleRadish.个人ID } } })
      // if (res.status !== 'success') this.$message.error(res.msg)
      // else this.handleRadish.rid = rid
    },
  },
}
</script>
<style scoped>
.table-box {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 8px;
  background-color: #f5f5f5;
}
.serch-company {
  padding: 8px 0;
}
.dialog-radish {
  position: fixed;
  background-color: #fff;
  border-radius: 6px;
  width: 500px;
  right: 200px;
  /* left: calc(50vw - 320px); */
  top: 150px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 2px rgba(232, 237, 250, 0.5);
  padding: 30px 17px;
  z-index: 3;
}
.closedialog {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  user-select: none;
  font-size: 18px;
  color: #e03838;
}
.handle_btn_box {
  padding: 6px 0;
}
.dialog-span {
  padding: 0 4px;
  color: #606266;
}
</style>
